export default {
  "update-job-phase-status-success": {
    EN: "Job Phase status updated successfully!",
  },
  "update-job-phase-status-failure": {
    EN: "Could not update job phase status",
  },
  "add-job-phase-costs-success": {
    EN: "Job Phase costs successfully added!",
  },
  "add-job-phase-costs-failure": {
    EN: "Could not add job phase costs",
  },
  "add-job-phase-file-success": {
    EN: "Successfully added file to the job phase",
  },
  "add-job-phase-file-failure": {
    EN: "Failed to add the file to the job phase",
  },
  "update-notes-success": {
    EN: "Successfully updated Job Phase notes",
  },
  "update-notes-failure": {
    EN: "Failed to update Job Phase notes",
  },
  "update-checklist-items-success": {
    EN: "Checklist items updated successfully",
  },
  "update-checklist-items-failure": {
    EN: "Failed to update checklist item",
  },
  "delete-job-phase-file-success": {
    EN: "Successfully deleted the job phase file",
  },
  "delete-job-phase-file-failure": {
    EN: "Failed to delete the job phase file",
  },
  "reordering-job-phase-success": {
    EN: "Successfully updated Job Schedule",
  },
  "reordering-job-phase-failure": {
    EN: "Failed to update Job Schedule",
  },
  "update-work-order-items-success": {
    EN: "Sucessfully updated Work Order items",
  },
  "update-work-order-items-failure": {
    EN: "Failed to update Work Order items",
  },
  "update-job-phase-plant-success": {
    EN: "Sucessfully updated Job Phase Plant",
  },
  "update-job-phase-plant-failure": {
    EN: "Failed to update  Job Phase Plant",
  },
};
